import {
  FileText,
  BarChart3,
  Mic,
  Newspaper,
  Package,
  Sparkles,
  Factory,
  LayoutGrid,
  File,
} from "lucide-react";

// Shared per-content-type identity used across every search surface (desktop
// dropdown, mobile dropdown, results page): a display label + a distinct icon.
// Keeping this in one place means all three surfaces stay visually consistent.
export const TYPE_META = {
  blog: { label: "Blogs", Icon: FileText },
  "case-study": { label: "Case Studies", Icon: BarChart3 },
  podcast: { label: "Podcasts", Icon: Mic },
  news: { label: "News", Icon: Newspaper },
  product: { label: "Products", Icon: Package },
  "ai-solution": { label: "AI Solutions", Icon: Sparkles },
  industry: { label: "Industries", Icon: Factory },
  service: { label: "Services", Icon: LayoutGrid },
  page: { label: "Pages", Icon: File },
};

export function metaFor(type) {
  return TYPE_META[type] || { label: "Result", Icon: File };
}

// Group a flat, relevance-sorted result array into ordered groups. Groups appear
// in first-match order — i.e. the most relevant category surfaces first — which
// is better UX than a fixed category order.
export function groupResults(results) {
  const map = new Map();
  for (const r of results || []) {
    if (!map.has(r.type)) {
      const m = metaFor(r.type);
      map.set(r.type, {
        type: r.type,
        label: r.typeLabel || m.label,
        Icon: m.Icon,
        items: [],
      });
    }
    map.get(r.type).items.push(r);
  }
  return Array.from(map.values());
}
